import { gql } from '@apollo/client';
export const GET_FILTER_COUNT = gql `
  query GET_FILTER_COUNT($id: Int!) {
    getFilterCount(id: $id)
  }
`;
export const EVALUATE_FILTER = gql `
  query EVALUATE_FILTER($id: Int!) {
    evaluateFilter(id: $id)
  }
`;
export const TEST_FILTER = gql `
  query TEST_FILTER($input: FilterInput!) {
    testFilter(input: $input) {
      found
      total
      error
    }
  }
`;
export const TEST_POPULATION_COVERAGE = gql `
  query TEST_POPULATION_COVERAGE($clientId: Int!) {
    testPopulationCoverage(clientId: $clientId) {
      found
      total
    }
  }
`;
